module.exports = __webpack_public_path__ + "media/nav/artkiveLogo-98bc9ace.svg";